<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="580"
      content-class="rounded-lg"
      scrollable
      @keydown.esc="dialog = false"
    >
      <v-card>
        <v-card-title class="h6">
          <span class="black--text text-uppercase font-weight-bold">{{title}}</span>
          <v-spacer></v-spacer>
          <v-btn text small color="pink" class="mr-n4" @click="modalHide">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0" id="contener">
          <v-form ref="formAddAddress" role="form">
            <div class="py-0">
              <v-divider class="d-none"></v-divider>
            </div>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Label Alamat</div>
                  <v-text-field
                    v-model="name"
                    :rules="rules.name"
                    validate-on-blur
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    placeholder="Contoh : Kantor, Rumah, Kos"
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Nama Penerima</div>
                  <v-text-field
                    v-model="receipt_name"
                    :rules="rules.receipt_name"
                    validate-on-blur
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    placeholder="Isi Nama Lengkap"
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Nomor Telepon</div>
                  <v-text-field
                    v-model="mobilephone"
                    :rules="rules.mobilephone"
                    @keypress="onlyNumber"
                    @paste.prevent
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    placeholder="081234567890"
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Provinsi</div>
                  <v-autocomplete
                    v-model="province"
                    :rules="rules.province"
                    :items="provinces"
                    item-text="provinsi_name"
                    item-value="id"
                    return-object
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    hide-details="auto"
                    no-data-text="Tidak ada data"
                    @change="changeProvince(province.id)"
                  ></v-autocomplete>
                </div>
                <div class="pb-4" v-if="province">
                  <div class="text-body-1 font-weight-bold pb-1">Kota/Kabupaten</div>
                  <v-autocomplete
                    v-model="city"
                    :rules="rules.city"
                    :items="cities"
                    :item-text="item => item.type + ' ' + item.kabupaten_name"
                    item-value="city_id"
                    return-object
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    hide-details="auto"
                    no-data-text="Tidak ada data"
                    @change="changeCity(city.id)"
                  >
                    <template v-slot:item="{item}">{{ item.type }} {{ item.kabupaten_name }}</template>
                    <template v-slot:selection="{item}">{{ item.type }} {{ item.kabupaten_name }}</template>
                  </v-autocomplete>
                </div>
                <div class="pb-4" v-if="city" id="coba">
                  <div class="text-body-1 font-weight-bold pb-1">Kecamatan</div>
                  <v-autocomplete
                    v-model="subdistrict"
                    :rules="rules.subdistrict"
                    :items="subdistricts"
                    item-text="kecamatan_name"
                    item-value="id"
                    return-object
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    height="45"
                    dense
                    hide-details="auto"
                    no-data-text="Tidak ada data"
                    @change="changeSubdistrict(subdistrict.postal_code)"
                  ></v-autocomplete>
                </div>
                <div class="pb-4" v-if="city">
                  <div class="text-body-1 font-weight-bold pb-1">Kode Pos</div>
                  <v-col cols="6" class="pa-0">
                    <v-text-field
                      v-model="zipcode"
                      single-line
                      outlined
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      placeholder="Kode Pos"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </div>
                <div class="pb-4" v-if="city">
                  <div class="text-body-1 font-weight-bold pb-1">Alamat Lengkap</div>
                  <v-textarea
                    v-model="detail"
                    :rules="rules.detail"
                    single-line
                    outlined
                    class="rounded-lg text-body-1"
                    placeholder="Isi nama jalan, nomor rumah, nama gedung, dsb"
                    hide-details="auto"
                    no-resize
                    minlength="20"
                  ></v-textarea>Minimal 20 karakter
                </div>
                <div class="pb-4">
                  <div class="text-body-1 font-weight-bold pb-1">Atur Lokasi</div>
                  <v-col cols="6" class="pa-0">
                    <!-- <v-text-field
                      single-line
                      outlined
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      placeholder="Cari Lokasi"
                      hide-details="auto"
                    ></v-text-field>-->
                    <!-- <GoogleMap /> -->
                  </v-col>
                  <div class="pt-1">
                    <!-- <GoogleMap ref="gmap" /> -->
                    <div>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="#1951EF"
                          depressed
                          class="text-capitalize font-weight-bold rounded-sm green--text"
                          height="30"
                          width="120"
                          @click="geolocate"
                        >Lokasi Saya</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                      <br />
                      <div>
                        <!-- <h2>Search and add a pin</h2> -->
                        <GmapAutocomplete
                          single-line
                          outlined
                          :placeholder="'Cari Lokasi'"
                          style="width:100%;"
                          class="v-text-field"
                          @place_changed="setPlace"
                        />
                      </div>
                      <br />
                      <GmapMap
                        :center="center"
                        :zoom="18"
                        map-style-id="roadmap"
                        :options="mapOptions"
                        ref="mapRef"
                        @click="handleMapClick"
                        style="width:100%;  height: 200px;"
                      >
                        <GmapMarker
                          :position="marker.position"
                          :clickable="true"
                          :draggable="true"
                          @click="panToMarker"
                          @drag="handleMarkerDrag"
                        />
                      </GmapMap>
                    </div>
                    LatLon: {{latitude}}, {{longitude}}
                  </div>
                </div>
                <!-- <div class="pb-4" v-if="false">
                  <div class="text-body-1 font-weight-bold pb-1">Atur Lokasi</div>
                  <v-col cols="6" class="pa-0">
                    <v-text-field
                      single-line
                      outlined
                      class="rounded-lg text-body-1"
                      height="45"
                      dense
                      placeholder="Cari Lokasi"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <div class="pt-1">Map disini</div>
                </div>-->
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#1951EF"
            depressed
            class="text-capitalize font-weight-bold rounded-lg white--text"
            height="45"
            width="150"
            @click="saveAddress"
          >Simpan</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
import $ from "jquery";
// import GoogleMap from "./GoogleMap.vue";
export default {
  components: {
    // GoogleMap
  },
  data() {
    return {
      mapOptions: {
        disableDefaultUI: true,
        zoomControl: true
      },
      marker: { position: { lat: 45.508, lng: -73.587 } },
      center: { lat: 45.508, lng: -73.587 },
      currentPlace: null,
      markers: [],
      places: [],
      rules: {
        name: [v => !!v || "Label Alamat tidak boleh kosong"],
        receipt_name: [v => !!v || "Nama Penerima tidak boleh kosong"],
        mobilephone: [
          v => !!v || "Nomor Telepon tidak boleh kosong",
          v => (v.length > 9 && v.length < 14) || "Format tidak sesuai"
        ],
        province: [v => !!v || "Provinsi tidak boleh kosong"],
        city: [v => !!v || "Kota tidak boleh kosong"],
        subdistrict: [v => !!v || "Kecamatan tidak boleh kosong"],
        detail: [
          v => !!v || "Detail tidak boleh kosong",
          v => v.length > 20 || "Minimal 20 karakter"
        ]
      },
      title: "Tambah Alamat",
      id: "",
      name: "",
      detail: "",
      province: null,
      city: null,
      subdistrict: null,
      zipcode: "",
      receipt_name: "",
      mobilephone: "",
      // longitude: "",
      // latitude: "",
      dialog: false
    };
  },
  props: {},
  computed: {
    latitude: {
      get() {
        return this.$store.state.kiriminaja.latitude;
      },
      set(newName) {
        return newName;
      }
    },
    longitude: {
      get() {
        return this.$store.state.kiriminaja.longitude;
      },
      set(newName) {
        return newName;
      }
    },
    ...mapState("kiriminaja", ["provinces", "cities", "subdistricts"])
  },
  methods: {
    // addMarker(lat, lon) {
    //   //   if (this.currentPlace) {
    //   const marker = {
    //     lat: lat,
    //     lng: lon
    //   };
    //   this.markers.push({ position: marker });
    //   this.places.push(this.currentPlace);
    //   this.center = marker;
    //   this.currentPlace = null;
    //   //   }
    // },
    //Moves the map view port to marker
    panToMarker() {
      this.$refs.mapRef.panTo(this.marker.position);
    },
    handleMapClick(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      let data = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      this.actLatLon(data);

      // this.purchaseForm.header.header_recipient_latitude = data.latitude;
      // this.purchaseForm.header.header_recipient_longitude = data.longitude;

      // console.log(e);
    },
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      let data = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng()
      };
      this.actLatLon(data);

      // this.purchaseForm.header.header_recipient_latitude = data.latitude;
      // this.purchaseForm.header.header_recipient_longitude = data.longitude;
    },
    async setPlace(place) {
      this.currentPlace = await place;
      //   console.log("place", place);
      //   console.log("geometry", place.geometry.location.lat());
      this.center = await {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      let data = {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng()
      };
      this.actLatLon(data);
      this.marker.position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };
      this.panToMarker();
      // await this.addMarker(data.latitude, data.longitude);
    },
    geolocate: function() {
      //   this.lokasi = "";
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        let data = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        this.actLatLon(data);
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.panToMarker();
        //   await this.addMarker();
        // this.addMarker(data.latitude, data.longitude);
      });
    },
    ...mapActions("kiriminaja", [
      "getProvince",
      "getCity",
      "getSubdistrict",
      "actLatLon"
    ]),

    modalShow(address) {
      // console.log("addre", address);
      this.dialog = true;
      if (address) {
        this.province = this.provinces.find(
          el => el.id == address.user_address_province_id
        );
        this.city = this.cities.find(
          el => el.id == address.user_address_city_id
        );
        this.subdistrict = this.subdistricts.find(
          el => el.id == address.user_address_subdistrict_id
        );
        this.title = "Ubah Alamat";
        this.id = address.user_address_id;
        this.name = address.user_address_name;
        this.zipcode = address.user_address_zipcode;
        this.detail = address.user_address_detail;
        this.receipt_name = address.user_address_receipt_name;
        this.mobilephone = address.user_address_mobilephone;
        // this.longitude = address.user_address_longitude;
        // this.latitude = address.user_address_latitude;
        if (
          address.user_address_longitude != "" &&
          address.user_address_latitude != ""
        ) {
          let data = {
            latitude: address.user_address_latitude,
            longitude: address.user_address_longitude
          };
          // console.log("dataaaa", data);
          this.actLatLon(data);
          this.center = {
            lat: parseFloat(address.user_address_latitude),
            lng: parseFloat(address.user_address_longitude)
          };
          this.marker.position = {
            lat: parseFloat(address.user_address_latitude),
            lng: parseFloat(address.user_address_longitude)
          };

          // console.log("this.marker.position", this.marker.position);
          this.panToMarker();
          // this.addMarker(
          //   parseFloat(address.user_address_latitude),
          //   parseFloat(address.user_address_longitude)
          // );

          // this.$emit("addMarker", data);
        }
      } else {
        this.title = "Tambah Alamat";
        this.id = "";
        this.name = "";
        this.detail = "";
        this.province = null;
        this.city = null;
        this.subdistrict = null;
        this.zipcode = "";
        this.receipt_name = "";
        this.mobilephone = "";
        this.longitude = "";
        this.latitude = "";
        let data = {
          latitude: "",
          longitude: ""
        };
        this.actLatLon(data);
      }
    },
    modalHide() {
      this.dialog = false;
    },
    saveAddress() {
      if (this.$refs.formAddAddress.validate()) {
        let param = {
          name: this.name,
          detail: this.detail,
          province_id: this.province.id,
          province_name: this.province.provinsi_name,
          city_id: this.city.id,
          city_type: this.city.type,
          city_name: this.city.kabupaten_name,
          subdistrict_id: this.subdistrict.id,
          subdistrict_name: this.subdistrict.kecamatan_name,
          zipcode: this.zipcode,
          receipt_name: this.receipt_name,
          mobilephone: this.mobilephone,
          longitude: this.longitude,
          latitude: this.latitude
        };
        if (this.id) param["id"] = this.id;
        this.$emit("action", param);
        this.modalHide();
      }
    },
    changeProvince(id) {
      this.city = null;
      this.subdistrict = null;
      this.getCity({
        province_id: id
      });
    },
    changeCity(id) {
      this.subdistrict = null;
      this.zipcode = null;
      this.getSubdistrict({
        city_id: id
      }).then(() => {
        var as = $("#coba").offset().top;
        as -= 90;
        $("#contener").scrollTop(as);
      });
    },
    changeSubdistrict(code) {
      this.zipcode = code;
    }
  },
  created() {
    this.getProvince();
  }
};
</script>